import { render, staticRenderFns } from "./SubjectDetail.vue?vue&type=template&id=27b5a7a4"
import script from "../../controllers/subject/subject-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/subject/subject-detail.js?vue&type=script&lang=js&external"
import style0 from "./SubjectDetail.vue?vue&type=style&index=0&id=27b5a7a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports